import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Herosection extends Component {
    render() {
        return (<div className="row align-items-center px-3 px-lg-5">

            {/* TEXT COLUMN */}
            <div className="col-12 col-lg-6 text-center text-lg-left mb-5 mb-lg-0">
                <div className="hero-content">

                    <h1 className="hero-title">
                        <span>Complete Identity Verification Platform for Modern Businesses</span>
                    </h1>

                    <p className="hero-description mt-4">
                        Deploy enterprise-grade identity verification in minutes. One unified API for face matching,
                        liveness detection, document authentication, and fraud prevention. Trusted by fintech,
                        banking, and crypto platforms worldwide.
                    </p>

                    {/* BUTTON GROUP */}
                    <div className="row d-flex flex-sm-row mt-4">
                        <div className="col-6 col-md-6 col-lg-6">
                            <a
                                href="https://nafsi-admin.windeal.co.ke/auth/login-1"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn w-button w-100"
                            >
                                Discover Our Solution
                                <i className="las la-angle-right ml-2"></i>
                            </a>
                        </div>
                        <div className="col-6 col-md-6 col-lg-6">
                            <Link to="/get-quote" className="btn w-button-outline w-100">
                                Get Quote
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* IMAGE COLUMN */}
            <div className="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-center">
                <img
                    src={require('../../assets/images/hero/nafsi-hero.svg')}
                    className="hero-image"
                    alt="Nafsi Identity Verification"
                />
            </div>
        </div>);
    }
}

export default Herosection;
